import { useMutation } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { IServerError, IVerifyData } from '../../types';
import { getClientId } from '../../helpers';

const {
  BASE, CONTROLLERS: {
    SECURITY: {
      VERSION, BASE: SECURITY_BASE, ROUTES: {
        VERIFY: { BASE: VERIFY_BASE, VARIABLES: { CUSTOMER, AUTHID }, SUB_ROUTES: { RESEND } },
      },
    },
  },
} = USER;

const urlMap = {
  verify: {
    DEFAULT: `${BASE_URL}/${BASE.replace('{version}', VERSION)}/${SECURITY_BASE}/{customerId}/${VERIFY_BASE}`,
    ACCOUNTANT: `${BASE_URL}/api/v1/user/openauth/{customerId}/authorized/user/{authUserId}/login/mfa`,
  },
  resend: {
    DEFAULT: `${BASE_URL}/${BASE.replace('{version}', VERSION)}/${SECURITY_BASE}/{customerId}/${VERIFY_BASE}/${RESEND}`,
    ACCOUNTANT: `${BASE_URL}/api/v1/user/openauth/{customerId}/authorized/user/{authUserId}/login/mfa/${RESEND}`,
  },
};

const getUrl = (customerId: string, authUserType?: string, authUserId?: string, resendRequest?: boolean) => {
  if (!resendRequest) {
    if (authUserType) {
      return urlMap.verify[authUserType as keyof typeof urlMap.verify]
        .replace(CUSTOMER, customerId)
        .replace(AUTHID, authUserId || '');
    }
    return urlMap.verify.DEFAULT.replace(CUSTOMER, customerId);
  }
  if (authUserType) {
    return urlMap.resend[authUserType as keyof typeof urlMap.resend]
      .replace(CUSTOMER, customerId)
      .replace(AUTHID, authUserId || '');
  }
  return urlMap.resend.DEFAULT.replace(CUSTOMER, customerId);
};

export const useVerifyMutation = (resendRequest?: boolean, onSuccess?: (status: string) => void, onError?: (errorObj: IServerError) => void) => useMutation(
  async ({
    customerId, authUserType, authUserId, ...verifyDetails
  }: IVerifyData) => {
    verifyDetails.clientId = getClientId() ?? '';
    const { data } = await httpService.post(getUrl(customerId, authUserType, authUserId, resendRequest), verifyDetails);
    return data;
  },
  {
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data?.status || '');
    },
    onError: (errorObj: IServerError) => {
      if (onError) onError(errorObj);
    },
  },
);
